import React, { useState, useEffect } from 'react';
import { apiCache } from '../utils/apiCache';

const CacheDebug = () => {
  const [stats, setStats] = useState({ memorySize: 0, storageSize: 0 });
  const [show, setShow] = useState(false);
  const [isCompact, setIsCompact] = useState(false);

  useEffect(() => {
    if (show) {
      const interval = setInterval(() => {
        setStats(apiCache.getStats());
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [show]);

  useEffect(() => {
    const updateBreakpoint = () => {
      setIsCompact(window.innerWidth <= 480);
    };

    updateBreakpoint();
    window.addEventListener('resize', updateBreakpoint);
    return () => window.removeEventListener('resize', updateBreakpoint);
  }, []);

  // Only show in development
  if (process.env.NODE_ENV !== 'development') return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: isCompact ? 'auto' : '20px',
      left: isCompact ? 'auto' : '20px',
      top: isCompact ? '12px' : 'auto',
      right: isCompact ? '12px' : 'auto',
      zIndex: 99999,
      background: 'rgba(0, 0, 0, 0.9)',
      color: '#46d369',
      padding: '10px',
      borderRadius: '8px',
      fontSize: '12px',
      fontFamily: 'monospace',
      border: '1px solid #46d369'
    }}>
      <button
        onClick={() => setShow(!show)}
        style={{
          background: '#0086f8',
          color: 'white',
          border: 'none',
          padding: '5px 10px',
          borderRadius: '4px',
          cursor: 'pointer',
          marginBottom: show ? '10px' : 0
        }}
      >
        {show ? '📊 Hide' : '📊 Cache Stats'}
      </button>

      {show && (
        <div>
          <div>Memory: {stats.memorySize}</div>
          <div>Storage: {stats.storageSize}</div>
          <div>Total: {stats.totalSize}</div>
          <button
            onClick={() => {
              apiCache.clear();
              setStats({ memorySize: 0, storageSize: 0 });
            }}
            style={{
              background: '#ff4444',
              color: 'white',
              border: 'none',
              padding: '3px 8px',
              borderRadius: '4px',
              cursor: 'pointer',
              marginTop: '5px',
              fontSize: '11px'
            }}
          >
            Clear Cache
          </button>
        </div>
      )}
    </div>
  );
};

export default CacheDebug;
